import { useNavigate, useLocation } from "react-router-dom";
import { Context } from "../Reducers/Store";
import React, { useContext, useState, useRef, useEffect } from "react";
import styled from "styled-components";

import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";

import LogoURL from "../Assets/Images/logo-regular.png";
import MiniLogoURL from "../Assets/Images/favicon-icon.png";

import FinancialIcon from "../Assets/SvgComponents/FinancialIcon";
import OrdersIcon from "../Assets/SvgComponents/OrdersIcon";
import DashIcon from "../Assets/SvgComponents/DashIcon";
import InputsIcon from "../Assets/SvgComponents/InputsIcon";
import UsersIcon from "../Assets/SvgComponents/UsersIcon";
import EventsIcon from "../Assets/SvgComponents/EventsIcon";
import ChannelIcon from "../Assets/SvgComponents/ChannelIcon";
import LogoutIcon from "../Assets/SvgComponents/LogoutIcon";
import IdSettingsIcon from "../Assets/SvgComponents/IdSettingsIcon";
import OnDemandIcon from "../Assets/SvgComponents/OnDemandIcon";
import SeriesIcon from "../Assets/SvgComponents/SeriesIcon";
import AccountIcon from "../Assets/SvgComponents/AccountIcon";

const Sidebar = ({ expanded, setExpanded }) => {
  const [state, dispatch] = useContext(Context);
  let navigate = useNavigate();
  let location = useLocation();
  const menuIndex = useRef(0);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    menuIndex.current = 0;
  });

  const handleLogout = () => {
    dispatch([
      { type: "SET_LOGGED", payload: null },
      { type: "SET_CHURCH", payload: null },
    ]);
    navigate("/login", { replace: false });
  };

  const handleNavigate = (event, to, currentIndex) => {
    navigate(to, { replace: false });
    setIndex(currentIndex);
    event.preventDefault();
  };

  const MiniLogo = styled.div`
    height: 56px;
    width: 56px;
    display: ${expanded ? "none" : "block"};
    margin: 17px auto 10px auto;
  `;

  const renderMenuItem = (title, eventKey, icon, csId) => {
    const currentIndexItem = menuIndex.current;
    menuIndex.current++;
    return (
      <NavItem id={"tooltip-" + csId} eventKey={eventKey} onClick={(e) => handleNavigate(e, eventKey, currentIndexItem)}>
        {!expanded && <span className="tooltiptext">{title}</span>}
        <NavIcon>
          {icon}
        </NavIcon>
        <NavText>{title}</NavText>
      </NavItem>
    );
  }

  return (
    <div>
      <SideNav
        duration={0}
        className="left-menu"
        expanded={expanded}
        onToggle={setExpanded}
        style={{
          backgroundColor: "#fff",
          color: "#9E9E9E",
          position: "fixed",
          width: 64,
          margin: 20,
          borderRadius: 24,
          boxShadow: "5px 6px 19px rgba(62, 72, 118, 0.04)",
        }}
      >
        <SideNav.Toggle className="menu-toggle" />
        <MiniLogo>
          <img className="mini-logo-nav" src={MiniLogoURL} />
        </MiniLogo>
        <NavHeader expanded={expanded}>
          <Logo className="cs-logo" src={LogoURL} />
        </NavHeader>
        <SideNav.Nav defaultSelected={location.pathname} style={{ backgroundPositionY: index * 50 }}>
          {(state.profile?.role == "ROLE_CHURCH_ADMIN" || state.profile?.role == "ROLE_CHURCH_PRODUCER") && renderMenuItem("Dashboard", "/", <DashIcon fill={"#9E9E9E"} />, "dashboard")}
          {(state.profile?.role == "ROLE_CHURCH_ADMIN" || state.profile?.role == "ROLE_CHURCH_PRODUCER") && renderMenuItem("Events", "/listingEvents", <EventsIcon fill={"#9E9E9E"} />, "events")}
          {state.profile?.role == "ROLE_CHURCH_ADMIN" && renderMenuItem("Inputs", "/listingInputs", <InputsIcon fill={"#9E9E9E"} />, "inputs")}
          {state.profile?.role == "ROLE_CHURCH_ADMIN" && renderMenuItem("Channels", "/listingChannels", <ChannelIcon fill={"#9E9E9E"} />, "channels")}
          {state.profile?.role == "ROLE_CHURCH_ADMIN" && renderMenuItem("Users", "/users", <UsersIcon fill={"#9E9E9E"} />, "users")}
          {(state.profile?.role == "ROLE_CHURCH_ADMIN" || state.profile?.role == "ROLE_CHURCH_MEDIA_MANAGER") && renderMenuItem("Video Archive", "/videoArchive", <OnDemandIcon stroke={"#9E9E9E"} />, "archive")}
          {(state.profile?.role == "ROLE_CHURCH_ADMIN" || state.profile?.role == "ROLE_CHURCH_MEDIA_MANAGER") && renderMenuItem("Series", "/videoArchive/series", <SeriesIcon stroke={"#9E9E9E"} />, "series")}
          {state.profile?.role == "ROLE_CHURCH_ADMIN" && renderMenuItem("On Demand Settings", "/ondemandsettings", <IdSettingsIcon stroke={"#9E9E9E"} />, "ondemand")}
          {state.profile?.role == "ROLE_CHURCH_ADMIN" && renderMenuItem("Account", "/account", <AccountIcon fill={"#9E9E9E"} />, "account")}

          <NavItem onClick={handleLogout} style={{ bottom: 10, width: "100%", position: "absolute" }}>
            <NavIcon>
              <LogoutIcon fill={"#9E9E9E"} />
            </NavIcon>
            <NavText style={{ color: "#37BB9C" }}>Logout</NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
    </div>
  );
};

export default Sidebar;

const NavHeader = styled.div`
  display: ${(props) => (props.expanded ? "flex" : "none")};
  white-space: nowrap;
  align-items: center;
`;
const Logo = styled.img``;
